import { convertArrayToObject } from "Services/Entity/helper";
import { getActionType } from "Store/Shared/Actions/Helpers";
import ACTIONS from "./ActionTypes";
import { initialContactModuleState } from "./PropTypes";

export default function contactModuleReducer(state = initialContactModuleState, action: any) {
    const { payload }  = action;
    switch (action.type) {
        case getActionType(ACTIONS.FETCH_ALL_CONTACT_MODULES).REQUEST: {
            return {
                ...state,
                _isFetching: true
            }
        }

        case getActionType(ACTIONS.CREATE_CONTACT_MODULE).REQUEST: {
            return {
                ...state,
                _isCreating: true
            }
        }

        case getActionType(ACTIONS.PATCH_CONTACT_MODULE).REQUEST: {
            return {
                ...state,
                _isPatching: true
            }
        }

        case getActionType(ACTIONS.DELETE_CONTACT_MODULE).REQUEST: {
            return {
                ...state,
                _isDeleting: true
            }
        }

        case getActionType(ACTIONS.FETCH_ALL_CONTACT_MODULES).SUCCESS: {
            const { data } = payload;

            const ids = data.map(i => i.id);
            const entities = convertArrayToObject(data, 'id');
            const byEntityId: any = {};
            const byEntityIdByType: any = {};
            data.forEach((item: any) => {
                if (!byEntityId[item.entity_id]) byEntityId[item.entity_id] = [];
                byEntityId[item.entity_id].push(item.id);
                
                if (!byEntityIdByType?.[item.entity_id]) byEntityIdByType[item.entity_id] = {};
                if (!byEntityIdByType?.[item.entity_id]?.[item.type]) byEntityIdByType[item.entity_id][item.type] = [];
                byEntityIdByType[item.entity_id][item.type].push(item.id);
            });

            return {
                ...state,
                _isFetching: false,
                ids,
                entities,
                byEntityId,
                byEntityIdByType
            }
        }

        case getActionType(ACTIONS.CREATE_CONTACT_MODULE).SUCCESS: {
            const { data } = payload;

            const ids = [data.id, ...state.ids];
            const entities = {
                ...state.entities,
                [data.id]: data
            };
            const byEntityId = {
                ...state.byEntityId,
                [data.entity_id]: [
                    data.id,
                    ...(state.byEntityId?.[data.entity_id] || [])
                ]
            };
            
            const byEntityIdByType = {
                ...state.byEntityIdByType,
                [data.entity_id]: {
                    ...(state.byEntityIdByType?.[data.entity_id] || {}),
                    [data.type]: [
                        data.id,
                        ...(state.byEntityIdByType?.[data.entity_id]?.[data.type] || []),
                    ]
                }
            };

            return {
                ...state,
                _isCreating: false,
                ids,
                entities,
                byEntityId,
                byEntityIdByType
            }  
        }

        case getActionType(ACTIONS.PATCH_CONTACT_MODULE).SUCCESS: {
            const { data } = payload;

            return {
                ...state,
                _isPatching: false,
                entities: {
                    ...state.entities,
                    [data.id]: data
                }
            }
        }

        case getActionType(ACTIONS.DELETE_CONTACT_MODULE).SUCCESS: {
            const { data } = payload;

            const ids = [...state.ids].filter(i => i != data.id);
            const entities = {...state.entities};
            delete entities[data.id];

            const tempByEntityId = [ ...(state.byEntityId[data.entity_id] || []) ].filter(i => i != data.id);
            const byEntityId = {
                ...state.byEntityId
            }

            if (tempByEntityId.length == 0) {
                delete byEntityId[data.entity_id];
            } else {
                byEntityId[data.entity_id] = tempByEntityId;
            }

            const tempByEntityIdByType = [ ...(state.byEntityIdByType?.[data.entity_id]?.[data.type] || []) ].filter(i => i != data.id);
            const byEntityIdByType = {
                ...state.byEntityIdByType
            }

            if (tempByEntityIdByType.length == 0) {
                delete byEntityIdByType[data.entity_id][data.type];
            } else {
                byEntityIdByType[data.entity_id][data.type] = tempByEntityIdByType;
            }

            return {
                ...state,
                _isDeleting: false,
                ids,
                entities,
                byEntityId,
                byEntityIdByType
            }
        }

        default:
            return {...state};
    }
}